import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/rights/package',
  name: 'rightsPackage',
  component: () => import('@/views/apply/rights/package'),
  meta: {
    title: i18n.t('router.rights.rights_package_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/rights/detail',
  name: 'rightsDetail',
  component: () => import('@/views/apply/rights/detail'),
  meta: {
    title: i18n.t('router.rights.rights_detail_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/rights/config',
  name: 'rightsConfig',
  component: () => import('@/views/apply/rights/config'),
  meta: {
    title: i18n.t('router.rights.rights_config'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/rights.js